var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogOut03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log-out-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M22 21.9583L28.875 15.5M28.875 15.5L22 9.04166M28.875 15.5H12.375M16.5 21.9583C16.5 22.3401 16.5 22.531 16.4849 22.6964C16.3279 24.415 14.9804 25.8293 13.1794 26.1656C13.0062 26.198 12.804 26.2191 12.4002 26.2613L10.9958 26.4078C8.88591 26.6281 7.83091 26.7382 6.99279 26.4862C5.87528 26.1503 4.96295 25.3832 4.48412 24.377C4.125 23.6223 4.125 22.6251 4.125 20.6309V10.3691C4.125 8.37486 4.125 7.37773 4.48412 6.62304C4.96295 5.61678 5.87528 4.84969 6.99279 4.51376C7.83092 4.26181 8.88588 4.37192 10.9958 4.59215L12.4002 4.73874C12.8042 4.7809 13.0061 4.80198 13.1794 4.83435C14.9804 5.17074 16.3279 6.58496 16.4849 8.30361C16.5 8.46898 16.5 8.65987 16.5 9.04166",
    stroke: "#12153A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut03);
export default __webpack_public_path__ + "static/media/log-out-03.79ba4e711112692f3968976ed0fd97f8.svg";
export { ForwardRef as ReactComponent };